// ===== LANGUAGE TOGGLE =====
        function setLanguage(lang) {
            document.querySelectorAll('[data-en][data-jp]').forEach(el => {
                var val = lang === 'en' ? el.getAttribute('data-en') : el.getAttribute('data-jp');
                if (el.hasAttribute('data-use-html')) {
                    el.innerHTML = val;
                } else {
                    el.textContent = val;
                }
            });
            // Consent row: show links in both languages; checkbox only in EN
            document.querySelectorAll('.gdpr-consent').forEach(el => {
                var checkbox = el.querySelector('input[type=\"checkbox\"]');
                if (lang === 'jp') {
                    el.style.display = 'flex';
                    if (checkbox) {
                        checkbox.required = true;
                        checkbox.checked = false;
                        checkbox.style.display = '';
                    }
                } else {
                    el.style.display = 'flex';
                    if (checkbox) {
                        checkbox.style.display = '';
                        checkbox.required = true;
                        checkbox.checked = false;
                    }
                }
            });
            // Social links: switch between global and Japan accounts
            document.querySelectorAll('.social-icon[data-href-en][data-href-jp]').forEach(el => {
                el.href = lang === 'jp' ? el.getAttribute('data-href-jp') : el.getAttribute('data-href-en');
            });
            try { localStorage.setItem('language', lang); } catch(e) {}
        }

        // Initialize language (priority: saved preference > client IP country (Cloudflare) > EN)
        function getDefaultLangFromCountry(countryCode) {
            if (!countryCode) return null;
            return String(countryCode).toUpperCase() === 'JP' ? 'jp' : 'en';
        }

        let savedLang = null;
        try { savedLang = localStorage.getItem('language'); } catch(e) {}
        let initLang = (savedLang === 'en' || savedLang === 'jp') ? savedLang : 'en';

        var initBtn = document.querySelector(`[data-lang="${initLang}"]`);
        if (initBtn) initBtn.click();

        // If no preference saved yet, try a simple geo lookup (best effort; VPNs/CSP can affect it).
        // It won't override a language the user already chose.
        if (!(savedLang === 'en' || savedLang === 'jp')) {
            fetch('https://cloudflare.com/cdn-cgi/trace', { cache: 'no-store' })
                .then(function (res) { return res.text(); })
                .then(function (text) {
                    var chosen = null;
                    try { chosen = localStorage.getItem('language'); } catch (e) {}
                    if (chosen === 'en' || chosen === 'jp') return;

                    var m = text.match(/^loc=([A-Z]{2})/m);
                    var country = m ? m[1] : '';
                    var lang = getDefaultLangFromCountry(country) || 'en';
                    console.log({lang, country})
                    var btn = document.querySelector(`[data-lang="${lang}"]`);
                    if (btn) btn.click();
                })
                .catch(function () {});
        }

        document.querySelectorAll('.lang-btn').forEach(btn => {
            btn.addEventListener('click', function() {
                document.querySelectorAll('.lang-btn').forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                setLanguage(this.getAttribute('data-lang'));
            });
        });

        // ===== SCROLL REVEAL =====
        function revealOnScroll() {
            document.querySelectorAll('.scroll-reveal').forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.75) {
                    el.classList.add('visible');
                }
            });
        }

        window.addEventListener('scroll', revealOnScroll);
        revealOnScroll();

        // ===== PARTICLES =====
        function createParticles() {
            const container = document.getElementById('particlesContainer');
            for (let i = 0; i < 30; i++) {
                const particle = document.createElement('div');
                particle.classList.add('particle');
                particle.style.left = Math.random() * 100 + '%';
                particle.style.top = Math.random() * 100 + '%';
                particle.style.animationDelay = Math.random() * 20 + 's';
                particle.style.animationDuration = (15 + Math.random() * 25) + 's';
                container.appendChild(particle);
            }
        }

        createParticles();

        // ===== SPEED LINES =====
        function createSpeedLines(container) {
            for (let i = 0; i < 10; i++) {
                const line = document.createElement('div');
                line.classList.add('speed-line');
                line.style.top = Math.random() * 100 + '%';
                line.style.animationDelay = Math.random() * 2 + 's';
                line.style.animationDuration = (1.5 + Math.random() * 1) + 's';
                container.appendChild(line);
            }
        }

        if (document.getElementById('heroSpeedLines')) {
            createSpeedLines(document.getElementById('heroSpeedLines'));
        }
        if (document.getElementById('kvSpeedLines')) {
            createSpeedLines(document.getElementById('kvSpeedLines'));
        }

        // ===== SHOWREEL ACCORDION =====
        function openPanel(panel) {
            document.querySelectorAll('.sr-panel').forEach(p => p.classList.remove('active'));
            panel.classList.add('active');
        }

        // ===== SIGNUP HANDLERS =====
        // Klaviyo Lists — dual routing by language
        var KLAVIYO_LIST_JP = 'TgsfBj';     // WR X DANDADAN (Japan)
        var KLAVIYO_LIST_EN = 'Xm7egN';     // WR X DANDADAN (GLOBAL)
        var KLAVIYO_COMPANY_ID = 'WAmhx6';

        function handleSignup(event) {
            event.preventDefault();
            var form = event.target;
            var emailInput = form.querySelector('input[type="email"]');
            var email = emailInput.value;
            var submitBtn = form.querySelector('button[type="submit"]');
            var origText = submitBtn.textContent;

            // Disable button during submission
            submitBtn.disabled = true;
            submitBtn.textContent = '...';

            if (KLAVIYO_COMPANY_ID) {
                // Route to correct list based on language
                var activeLang = 'en';
                var langBtn = document.querySelector('.lang-btn.active');
                if (langBtn) activeLang = langBtn.getAttribute('data-lang') || 'en';
                var listId = activeLang === 'jp' ? KLAVIYO_LIST_JP : KLAVIYO_LIST_EN;

                // Production: POST to Klaviyo Client Subscribe API
                var klaviyoUrl = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
                var klaviyoBody = {
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'DDD x Williams Landing Page',
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: email
                                    }
                                }
                            }
                        },
                        relationships: {
                            list: {
                                data: {
                                    type: 'list',
                                    id: listId
                                }
                            }
                        }
                    }
                };

                console.log('Klaviyo request URL:', klaviyoUrl);
                console.log('Klaviyo request body:', JSON.stringify(klaviyoBody));
                console.log('Target list:', listId, '(lang:', activeLang, ')');

                fetch(klaviyoUrl, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        'revision': '2024-10-15'
                    },
                    body: JSON.stringify(klaviyoBody)
                }).then(function(res) {
                    console.log('Klaviyo response status:', res.status);
                    return res.text().then(function(t) {
                        console.log('Klaviyo response body:', t);
                        // 202 = accepted, 200 = ok — both are success
                        if (res.status === 202 || res.ok) {
                            showSignupSuccess(form, submitBtn, origText);
                        } else {
                            console.error('Klaviyo error:', res.status, t);
                            showSignupSuccess(form, submitBtn, origText);
                        }
                    });
                }).catch(function(err) {
                    console.error('Klaviyo fetch error:', err);
                    submitBtn.disabled = false;
                    submitBtn.textContent = origText;
                });
            } else {
                // Dev/mockup mode: show success state
                setTimeout(function() { showSignupSuccess(form, submitBtn, origText); }, 600);
            }
        }

        function showSignupSuccess(form, btn, origText) {
            var lang = 'en';
            try { lang = localStorage.getItem('language') || 'en'; } catch(e) {}
            btn.textContent = lang === 'jp' ? '✓ 登録完了！' : '✓ YOU\'RE IN!';
            btn.style.background = '#00c853';
            form.querySelector('input[type="email"]').value = '';
            setTimeout(function() {
                btn.disabled = false;
                btn.textContent = origText;
                btn.style.background = '';
            }, 3000);
        }

        function handleLine() {
            window.open('https://lin.ee/nQYIcyr', '_blank');
        }

        function scrollToSignup() {
            document.querySelector('.signup-form').scrollIntoView({ behavior: 'smooth' });
        }

        // ===== LEGAL MODALS =====
        function openLegal(type) {
            var content = document.getElementById('legalContent');
            var lang = 'en';
            var langBtn = document.querySelector('.lang-btn.active');
            if (langBtn) lang = langBtn.getAttribute('data-lang') || 'en';
            if (!langBtn) {
                try { lang = localStorage.getItem('language') || 'en'; } catch(e) {}
            }

            if (lang === 'jp') {
                if (type === 'privacy') {
                    content.innerHTML =
                        '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:1px;">プライバシー・クッキーポリシー</h2>' +
                        '<p style="opacity:0.5; margin-bottom:24px;">最終更新日：2026年3月</p>' +
                        '<p style="margin-bottom:16px;">本ポリシーは、株式会社UNDONE Japan（〒150-0001 東京都渋谷区神宮前6-31-15、代表取締役：Robert Tran Quoc Wai）が運営する本キャンペーンページに適用されます。本ページは、Atlassian Williams Racing および ダンダダン とのコラボレーション企画に関連して提供されており、当社はお客様の個人情報を適切に取り扱い、そのプライバシー保護に努めます。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">取得する情報について</h3>' +
                        '<p style="margin-bottom:12px;">当社は、本ページを通じて以下の情報を取得する場合があります。</p>' +
                        '<p style="margin-bottom:8px;"><strong>お客様が提供する情報</strong></p>' +
                        '<ul style="margin:0 0 12px 18px; padding:0;">' +
                            '<li>メールアドレス</li>' +
                        '</ul>' +
                        '<p style="margin-bottom:8px;"><strong>自動的に取得される情報</strong></p>' +
                        '<ul style="margin:0 0 12px 18px; padding:0;">' +
                            '<li>IPアドレス</li>' +
                            '<li>ブラウザの種類</li>' +
                            '<li>OS情報</li>' +
                            '<li>閲覧ページ</li>' +
                            '<li>クリック履歴</li>' +
                            '<li>滞在時間その他の利用状況</li>' +
                        '</ul>' +
                        '<p style="margin-bottom:12px;">当社は、必要な範囲に限って情報を保持し、利用目的に照らして合理的な期間保存します。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">個人情報の利用目的</h3>' +
                        '<p style="margin-bottom:8px;"><strong>1. マーケティング配信</strong></p>' +
                        '<p style="margin-bottom:12px;">本コラボレーションに関するお知らせ、アップデート、プロモーションメールの配信のため</p>' +
                        '<p style="margin-bottom:8px;"><strong>2. ウェブサイト改善</strong></p>' +
                        '<p style="margin-bottom:12px;">本ページの内容、構成、導線等を改善し、より良いユーザー体験を提供するため</p>' +
                        '<p style="margin-bottom:8px;"><strong>3. アナリティクスおよび広告配信</strong></p>' +
                        '<p style="margin-bottom:12px;">アクセス状況の測定、広告効果の分析、キャンペーンの最適化のため</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">第三者サービスの利用について</h3>' +
                        '<p style="margin-bottom:12px;">当社は、以下の外部サービスを利用する場合があります。これらのサービス提供者に対して、必要な範囲で情報が提供される場合があります。</p>' +
                        '<ul style="margin:0 0 12px 18px; padding:0;">' +
                            '<li>Klaviyo, Inc.：メールマーケティング配信（米国）</li>' +
                            '<li>Google Analytics（Google LLC）：アクセス解析（米国）</li>' +
                            '<li>Meta Platforms, Inc.：広告配信およびリマーケティング（米国）</li>' +
                        '</ul>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">お客様の権利について</h3>' +
                        '<p style="margin-bottom:12px;">お客様は、適用される法令に基づき、当社が保有するご自身の個人情報について、開示、訂正、削除、利用停止、処理の制限、データポータビリティ、同意の撤回等を求めることができます。ご請求は <a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a> までご連絡ください。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">保存期間および削除について</h3>' +
                        '<p style="margin-bottom:12px;">当社は、お客様がメール配信に登録している期間中、必要な範囲で個人情報を保持します。配信停止後は、原則として30日以内を目安に削除または適切な方法で管理します。削除をご希望の場合は <a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a> までご連絡ください。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">マーケティング配信の停止について</h3>' +
                        '<p style="margin-bottom:12px;">お客様は、当社からのメール内に記載された配信停止リンク、または <a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a> へのご連絡により、いつでもマーケティング配信を停止することができます。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Cookieについて</h3>' +
                        '<p style="margin-bottom:12px;">本ページでは、アクセス解析、利便性向上、広告配信の最適化等のためにCookieを使用する場合があります。Cookieの利用により、ブラウザ情報、閲覧履歴、行動履歴等が取得されることがありますが、これらには通常、直接的に個人を特定する情報は含まれません。なお、ブラウザ設定によりCookieを無効化することも可能ですが、その場合、本ページの一部機能が正しく動作しないことがあります。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">お問い合わせ</h3>' +
                        '<p><a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a><br>株式会社UNDONE Japan<br>〒150-0001 東京都渋谷区神宮前6-31-15</p>';
                } else {
                    content.innerHTML =
                        '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:1px;">利用規約</h2>' +
                        '<p style="opacity:0.5; margin-bottom:24px;">最終更新日：2026年3月</p>' +
                        '<p style="margin-bottom:16px;">本ページをご利用いただくことにより、以下の利用規約に同意したものとみなされます。本ページは、株式会社UNDONE Japan（〒150-0001 東京都渋谷区神宮前6-31-15、代表取締役：Robert Tran Quoc Wai）により運営されており、Atlassian Williams Racing および ダンダダン とのコラボレーション企画に関連して提供されています。当社は、必要に応じて本規約を予告なく変更する場合があります。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">商品および販売状況について</h3>' +
                        '<p style="margin-bottom:12px;">本ページで案内される商品は、UNDONE × ダンダダン × Williams Racing による限定コレクション（腕時計、アパレル、アクセサリー等）です。商品は在庫状況により販売数が変動し、売り切れとなる場合があります。また、ハンドメイド工程を含む商品の特性上、個体差が生じる場合がありますが、これらは不良ではありません。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">購入および支払いについて</h3>' +
                        '<p style="margin-bottom:12px;">商品の購入および決済は、当社または当社が利用する第三者プラットフォームを通じて処理されます。価格は undone.com では米ドル、undone.co.jp では日本円で表示され、別途、税金・関税・送料等が発生する場合があります。当社は、必要に応じて価格を予告なく変更する場合があります。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">配送およびお届けについて</h3>' +
                        '<p style="margin-bottom:12px;">商品は適切な梱包の上で発送されます。配送時期および到着までの日数は、発送先地域や生産スケジュール等により異なります。国際配送における関税、輸入税その他の費用は、お客様のご負担となる場合があります。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">返品・キャンセルについて</h3>' +
                        '<p style="margin-bottom:12px;">本商品は限定コレクターズアイテムのため、原則として返品・交換はお受けしておりません。すべてのご注文は最終確定となります。キャンセルをご希望の場合は、ご注文から1週間以内に <a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a> までご連絡ください。破損や不良がある場合は、商品到着後14日以内に、写真を添えてご連絡ください。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">サインアップおよびメール配信について</h3>' +
                        '<p style="margin-bottom:12px;">本ページからサインアップを行うことにより、本コレクションに関するマーケティングメールを受け取ることに同意したものとみなされます。メール配信はいつでも解除できます。個人情報の取扱いについては、当社のプライバシーポリシーに従います。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">知的財産権について</h3>' +
                        '<p style="margin-bottom:12px;">本ページに掲載されるコンテンツ、画像、文言、デザイン等に関する権利は、UNDONE、Atlassian Williams Racing、および各権利者に帰属します。ダンダダン に関する権利は 龍幸伸／集英社 に帰属し、アニメーション作品は Science SARU により制作されています。これらの素材は正規の許諾のもとで使用されており、無断転載・複製・改変・再配布を禁止します。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">準拠法および管轄</h3>' +
                        '<p style="margin-bottom:12px;">本規約は日本法に準拠し、本ページまたは本規約に関して生じる一切の紛争については、東京の裁判所を専属的合意管轄裁判所とします。</p>' +

                        '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">お問い合わせ</h3>' +
                        '<p><a href="mailto:spark@undone.co.jp" style="color:#fff; text-decoration:underline;">spark@undone.co.jp</a><br>株式会社UNDONE Japan<br>〒150-0001 東京都渋谷区神宮前6-31-15</p>';
                }
            } else {
                if (type === 'privacy') {
                    content.innerHTML = '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:2px;">PRIVACY &amp; COOKIES POLICY</h2>' +
                    '<p style="opacity:0.5; margin-bottom:24px;">Last updated: March 2026</p>' +
                    '<p style="margin-bottom:16px;">This policy applies to this campaign page, operated by UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan (Representative Director: Robert Tran Quoc Wai) in collaboration with Atlassian Williams Racing and DAN DA DAN. We are committed to protecting your information and respecting your privacy.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Data We Collect</h3>' +
                    '<p style="margin-bottom:12px;"><strong>Contact data</strong> (you provide): email address. <strong>User identification data</strong> (automatic): IP address, browser type, OS. <strong>User behaviour data</strong> (automatic): pages viewed, clickstreams, visit lengths. We hold only necessary data for as long as relevant.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">How Your Data Is Used</h3>' +
                    '<p style="margin-bottom:12px;"><strong>Marketing:</strong> email communications about this collaboration (legal basis: explicit consent). <strong>Website improvement:</strong> optimising content (legal basis: legitimate interest). <strong>Analytics/advertising:</strong> traffic measurement, ad effectiveness (legal basis: consent via cookies).</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Third-Party Processors</h3>' +
                    '<p style="margin-bottom:12px;"><strong>Klaviyo, Inc.</strong> — email marketing (USA). <strong>Google Analytics (Google LLC)</strong> — web analytics (USA). <strong>Meta Platforms, Inc.</strong> — advertising/remarketing (USA).</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Your Rights (GDPR)</h3>' +
                    '<p style="margin-bottom:12px;">Access, rectification, erasure, restrict processing, data portability, object to processing, withdraw consent. Contact: spark@undone.co.jp</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Data Retention &amp; Deletion</h3>' +
                    '<p style="margin-bottom:12px;">Retained while subscribed. Removed within 30 days of unsubscribe. Request deletion at spark@undone.co.jp.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Marketing &amp; Opting Out</h3>' +
                    '<p style="margin-bottom:12px;">Only with express consent. Opt out via unsubscribe link in emails or email spark@undone.co.jp.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Contact</h3>' +
                    '<p>spark@undone.co.jp | UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan</p>';
                } else {
                    content.innerHTML = '<h2 style="font-size:20px; margin-bottom:20px; letter-spacing:2px;">TERMS &amp; CONDITIONS</h2>' +
                    '<p style="opacity:0.5; margin-bottom:24px;">Last updated: March 2026</p>' +
                    '<p style="margin-bottom:16px;">By using this page you agree to these terms. Operated by UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan (Representative Director: Robert Tran Quoc Wai) in collaboration with Atlassian Williams Racing and DAN DA DAN. We may update terms at any time.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Products &amp; Availability</h3>' +
                    '<p style="margin-bottom:12px;">Limited edition UNDONE × DAN DA DAN × Williams Racing collection — watches, apparel, and accessories. Subject to availability. Handmade variations are normal, not defects.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Purchases &amp; Payments</h3>' +
                    '<p style="margin-bottom:12px;">Processed by third-party platforms. Prices in USD (undone.com) or JPY (undone.co.jp), excluding taxes/duties/shipping. We may modify pricing without notice.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Shipping &amp; Delivery</h3>' +
                    '<p style="margin-bottom:12px;">Protective packaging. Timelines vary by destination and production. International customs/duties are buyer\'s responsibility.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Returns &amp; Cancellations</h3>' +
                    '<p style="margin-bottom:12px;">Limited collectible: no returns/exchanges. All sales final. Cancel within 1 week at spark@undone.co.jp. Damaged items: contact within 14 days with photos.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Sign-Up &amp; Emails</h3>' +
                    '<p style="margin-bottom:12px;">By signing up you agree to receive marketing emails about this collection. Unsubscribe anytime. Data processed per Privacy Policy.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Intellectual Property</h3>' +
                    '<p style="margin-bottom:12px;">Content owned by UNDONE, Atlassian Williams Racing, and licensors. DAN DA DAN owned by Yukinobu Tatsu/SHUEISHA. Anime by Science SARU. Used under license. No reproduction without consent.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Governing Law</h3>' +
                    '<p style="margin-bottom:12px;">Laws of Japan. Exclusive jurisdiction: courts of Tokyo.</p>' +
                    '<h3 style="font-size:15px; margin:20px 0 10px; color:#0042FF;">Contact</h3>' +
                    '<p>spark@undone.co.jp | UNDONE Japan Co., Ltd., 6-31-15 Jingumae, Shibuya-ku, Tokyo 150-0001, Japan</p>';
                }
            }
            document.getElementById('legalModal').style.display = 'block';
        }

        // ===== CAROUSEL TIMER =====
        (function() {
            var carousel = document.getElementById('signupCarousel');
            if (!carousel) return;
            var imgs = carousel.querySelectorAll('img');
            var current = 0;
            setInterval(function() {
                imgs[current].classList.remove('active');
                current = (current + 1) % imgs.length;
                imgs[current].classList.add('active');
            }, 4000);
        })();

        // ===== NEON LINE SCROLL TRIGGER =====
        (function() {
            var lines = document.querySelectorAll('.checkered-strip, .racing-divider');
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting && !entry.target.classList.contains('neon-fired')) {
                        entry.target.classList.add('neon-fired');
                    }
                });
            }, { threshold: 0.5 });
            lines.forEach(function(el) { observer.observe(el); });
        })();

        // ===== PARALLAX on carousel BG =====
        (function() {
            var section = document.querySelector('.signup-section-2');
            if (!section) return;
            var imgs = section.querySelector('.carousel-bg');
            window.addEventListener('scroll', function() {
                var rect = section.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    var offset = (rect.top / window.innerHeight) * 30;
                    imgs.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
                }
            });
        })();

        // ===== SAFETY NET: ensure all sections are visible =====
        window.addEventListener('load', function() {
            document.querySelectorAll('.scroll-reveal').forEach(el => el.classList.add('visible'));
        });
